<div class="page-section series-form-page">
    <div class="app-l-page__navigation">
        <div
            class="app-l-page__previous"
            (click)="navigateToListingPage()"
            (keypress)="navigateToListingPage()">
            <button
                class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20">
                <svg-icon icon="arrow-left" class="w-100 h-100"></svg-icon>
            </button>
        </div>
        <div class="app-l-page__breadcrumbs">
            <ul class="breadcrumbs-list">
                <li class="breadcrumbs-list-item">
                    <a
                        (click)="navigateToListingPage()"
                        (keypress)="navigateToListingPage()"
                        >Series</a
                    >
                </li>
                <li class="breadcrumbs-list-item app-l-current-page">
                    {{ title }}
                </li>
            </ul>
        </div>
    </div>
    <div class="page-section-content">
        <page-loader *ngIf="!isLoaded"></page-loader>
        <form novalidate [formGroup]="courseEditForm" (ngSubmit)="doSave()">
            <div id="resource-section" class="form-wrapper-80" *ngIf="isLoaded">
                <div class="lang-Btn">
                    <a
                        tabindex="0"
                        class="app-c-btn app-c-btn--secondary app-c-btn--curve app-c-btn--sm"
                        (click)="showFrench = !showFrench"
                        (keypress)="showFrench = !showFrench"
                        [class.active]="showFrench"
                        >French</a
                    >
                    <a
                        tabindex="0"
                        class="app-c-btn app-c-btn--secondary app-c-btn--curve app-c-btn--sm"
                        (click)="showSpanish = !showSpanish"
                        (keypress)="showSpanish = !showSpanish"
                        [class.active]="showSpanish"
                        >Spanish</a
                    >
                </div>

                <div class="app-c-form-group">
                    <label class="app-c-form--label">Series Title</label>
                    <input
                        class="app-c-form-control"
                        formControlName="label"
                        type="text" />
                    <div
                        class="error-message"
                        *ngIf="f.label.touched && f.label.errors?.required">
                        The series needs a name.
                    </div>
                </div>
                <div class="app-c-form-group" *ngIf="showFrench">
                    <label class="app-c-form--label"
                        >Series Title (French)</label
                    >
                    <input
                        class="app-c-form-control"
                        formControlName="label_fr"
                        type="text" />
                </div>
                <div class="app-c-form-group" *ngIf="showSpanish">
                    <label class="app-c-form--label"
                        >Series Title (Spanish)</label
                    >
                    <input
                        class="app-c-form-control"
                        formControlName="label_es"
                        type="text" />
                </div>

                <div class="app-c-form-group">
                    <label class="app-c-form--label">Course Key</label>
                    <input
                        class="app-c-form-control"
                        type="text"
                        formControlName="key" />
                </div>

                <div
                    class="app-c-form-group"
                    *ngIf="seriesPageType != 'customType'">
                    <label class="app-c-form--label" translate
                        >Series Category</label
                    >
                    <select
                        class="app-c-form-control"
                        formControlName="category">
                        <option
                            *ngFor="let category of categoryList"
                            [ngValue]="category.ID">
                            {{ category.Title }}
                        </option>
                    </select>
                </div>

                <div class="icon-input" *ngIf="seriesPageType == 'customType'">
                    <div>
                        <multiselect-autocomplete
                            placeholder="Select an organization"
                            [items]="multiSelOrgs"
                            formControlName="orgIds"
                            [formValue]="courseEditForm.value.orgIds"
                            (onSelectItems)="
                                onSelectOrgs($event)
                            "></multiselect-autocomplete>
                    </div>
                </div>

                <!-- <div *ngIf="course.courseImage?.fileUpload">
                    <img
                        [alt]="course.courseImage?.fileFilename"
                        [src]="course.courseImage?.fileUpload"
                        style="
                            max-width: 300px;
                            max-height: 200px;
                            height: auto;
                        " />
                </div> -->
                <div class="icon-input">
                    <label for="courseImage">Series Image</label>
                    <input
                        type="file"
                        accept="image/png,image/jpeg,image/jpg,image/webp"
                        (change)="courseImageUpload($event)"
                        #input />
                    <small class="file-hint"
                        >PNG, JPG or WebP. Recommended ≤ 2&nbsp;MB.</small
                    >
                </div>

                <div
                    *ngIf="courseEditForm.value.imageUrl"
                    class="preview image-preview">
                    <p>Image preview</p>
                    <img
                        alt=""
                        [src]="courseEditForm.value.imageUrl"
                        style="
                            max-width: 300px;
                            max-height: 200px;
                            height: auto;
                        " />
                </div>

                <div class="icon-input">
                    <label class="app-c-form--label">Description</label>
                    <ckeditor
                        [editor]="Editor"
                        formControlName="description"
                        [config]="config"
                        id="courseDescription">
                    </ckeditor>
                </div>
                <div class="icon-input" *ngIf="showFrench">
                    <label class="app-c-form--label"
                        >Description (French)</label
                    >
                    <ckeditor
                        [editor]="Editor"
                        formControlName="description_fr"
                        [config]="config"
                        id="courseDescriptionFr">
                    </ckeditor>
                </div>
                <div class="icon-input" *ngIf="showSpanish">
                    <label class="app-c-form--label"
                        >Description (Spanish)</label
                    >
                    <ckeditor
                        [editor]="Editor"
                        formControlName="description_es"
                        [config]="config"
                        id="courseDescriptionEs">
                    </ckeditor>
                </div>

                <div class="app-c-form-group">
                    <label class="app-c-form--label">Course Length</label>
                    <input
                        class="app-c-form-control"
                        formControlName="length"
                        type="text" />
                </div>

                <div class="icon-input" *ngIf="seriesPageType != 'customType'">
                    <label class="app-c-form--label"
                        >Talk About Description</label
                    >
                    <ckeditor
                        [editor]="Editor"
                        formControlName="talkAboutDescription"
                        [config]="config"
                        id="courseItemDescription">
                    </ckeditor>
                </div>
                <div
                    class="icon-input"
                    *ngIf="showFrench && seriesPageType != 'customType'">
                    <label class="app-c-form--label"
                        >Talk About Description (French)</label
                    >
                    <ckeditor
                        [editor]="Editor"
                        formControlName="talkAboutDescriptionfr"
                        [config]="config"
                        id="courseItemDescriptionFr">
                    </ckeditor>
                </div>
                <div
                    class="icon-input"
                    *ngIf="showSpanish && seriesPageType != 'customType'">
                    <label class="app-c-form--label"
                        >Talk About Description (Spanish)</label
                    >
                    <ckeditor
                        [editor]="Editor"
                        formControlName="talkAboutDescriptiones"
                        [config]="config"
                        id="courseItemDescriptionEs">
                    </ckeditor>
                </div>
                <div
                    class="icon-input toggle-btn-container"
                    *ngIf="seriesPageType != 'customType'">
                    <label class="toggle-switch">
                        <input type="checkbox" formControlName="default" />
                        <span class="toggle-slider"></span>
                    </label>
                    <span class="toggle-label">Default?</span>
                </div>

                <div class="icon-input toggle-btn-container">
                    <label class="toggle-switch">
                        <input type="checkbox" formControlName="active" />
                        <span class="toggle-slider"></span>
                    </label>
                    <span class="toggle-label">Active?</span>
                </div>

                <div class="app-c-accordion">
                    <details
                        class="app-c-expansion-panel-container"
                        *ngFor="let chapter of chapters.controls; let i = index"
                        [formGroup]="getChapterFormGroup(i)">
                        <summary class="app-c-expansion-panel">
                            <span class="app-c-expansion-panel__title"
                                >Chapter {{ i + 1 }}</span
                            >
                            <span class="app-c-expansion-panel__description">
                                <svg-icon
                                    icon="angle-right"
                                    class="app-c-expansion-panel__arrow-icon"></svg-icon>
                            </span>
                        </summary>

                        <ng-container padding>
                            <div class="video-remove-btn">
                                <a
                                    class="remove"
                                    tabindex="0"
                                    (click)="onRemoveCourseItem(i)"
                                    (keypress)="onRemoveCourseItem(i)"
                                    ><img
                                        alt=""
                                        src="./assets/img/icons-svg/trash.svg"
                                /></a>
                            </div>
                            <div class="app-c-form-group">
                                <label class="app-c-form--label"
                                    >Chapter Name</label
                                >
                                <input
                                    class="app-c-form-control"
                                    type="text"
                                    formControlName="name" />
                                <div
                                    class="error-message"
                                    *ngIf="
                                        getChapterFormGroup(i).controls['name']
                                            .touched &&
                                        getChapterFormGroup(i).controls['name']
                                            .errors?.required
                                    ">
                                    Chapter needs a name
                                </div>
                            </div>
                            <div class="app-c-form-group" *ngIf="showFrench">
                                <label class="app-c-form--label"
                                    >Chapter Name (French)</label
                                >
                                <input
                                    class="app-c-form-control"
                                    type="text"
                                    formControlName="namefr" />
                            </div>
                            <div class="app-c-form-group" *ngIf="showSpanish">
                                <label class="app-c-form--label"
                                    >Chapter Name (Spanish)</label
                                >
                                <input
                                    class="app-c-form-control"
                                    type="text"
                                    formControlName="namees" />
                            </div>

                            <div class="icon-input">
                                <label class="app-c-form--label"
                                    >Description</label
                                >
                                <ckeditor
                                    [editor]="Editor"
                                    formControlName="description"
                                    [config]="config"
                                    id="chapterDescription_{{ i }}">
                                </ckeditor>
                            </div>
                            <div class="icon-input" *ngIf="showFrench">
                                <label class="app-c-form--label"
                                    >Description (French)</label
                                >
                                <ckeditor
                                    [editor]="Editor"
                                    formControlName="description_fr"
                                    [config]="config"
                                    id="chapterDescriptionFr_{{ i }}">
                                </ckeditor>
                            </div>
                            <div class="icon-input" *ngIf="showSpanish">
                                <label class="app-c-form--label"
                                    >Description (Spanish)</label
                                >
                                <ckeditor
                                    [editor]="Editor"
                                    formControlName="description_es"
                                    [config]="config"
                                    id="chapterDescriptionEs_{{ i }}">
                                </ckeditor>
                            </div>

                            <div class="app-c-form-group">
                                <label class="app-c-form--label"
                                    >Chapter Label</label
                                >
                                <input
                                    class="app-c-form-control"
                                    type="text"
                                    formControlName="label" />
                            </div>
                            <div class="app-c-form-group" *ngIf="showFrench">
                                <label class="app-c-form--label"
                                    >Chapter Label (French)</label
                                >
                                <input
                                    class="app-c-form-control"
                                    type="text"
                                    formControlName="label_fr" />
                            </div>
                            <div class="app-c-form-group" *ngIf="showSpanish">
                                <label class="app-c-form--label"
                                    >Chapter Label (Spanish)</label
                                >
                                <input
                                    class="app-c-form-control"
                                    type="text"
                                    formControlName="label_es" />
                            </div>
                            <div class="app-c-form-group">
                                <label class="app-c-form--label"
                                    >Chapter Length</label
                                >
                                <input
                                    class="app-c-form-control"
                                    type="text"
                                    formControlName="length" />
                            </div>
                        </ng-container>

                        <ng-container>
                            <h4>Videos</h4>
                            <div class="app-c-accordion">
                                <details
                                    class="app-c-expansion-panel-container video-panel-container"
                                    *ngFor="
                                        let video of getVideosList(i).controls;
                                        let j = index
                                    "
                                    [formGroup]="getVideoFormGroup(i, j)">
                                    <summary class="app-c-expansion-panel">
                                        <span
                                            class="app-c-expansion-panel__title"
                                            >Video {{ j + 1 }}:
                                            {{ video.value.label }}</span
                                        >

                                        <span
                                            class="app-c-expansion-panel__description">
                                            <svg-icon
                                                icon="angle-right"
                                                class="app-c-expansion-panel-video__arrow-icon"></svg-icon>
                                        </span>
                                    </summary>
                                    <div class="video-remove-btn">
                                        <a
                                            tabindex="0"
                                            class="remove"
                                            title="Remove this video"
                                            (click)="removeVideo(i, j, $event)"
                                            (keypress)="
                                                removeVideo(i, j, $event)
                                            "
                                            ><img
                                                alt=""
                                                src="./assets/img/icons-svg/trash.svg"
                                        /></a>
                                    </div>

                                    <div class="">
                                        <div class="app-c-form-group">
                                            <label class="app-c-form--label"
                                                >Video Title</label
                                            >
                                            <input
                                                class="app-c-form-control"
                                                type="text"
                                                formControlName="label" />
                                            <div
                                                class="error-message"
                                                *ngIf="
                                                    getVideoFormGroup(i, j)
                                                        .controls['label']
                                                        .touched &&
                                                    getVideoFormGroup(i, j)
                                                        .controls['label']
                                                        .errors?.required
                                                ">
                                                Video needs a title
                                            </div>
                                        </div>
                                        <div
                                            class="app-c-form-group"
                                            *ngIf="showFrench">
                                            <label class="app-c-form--label"
                                                >Video Title (French)</label
                                            >
                                            <input
                                                class="app-c-form-control"
                                                type="text"
                                                formControlName="label_fr" />
                                        </div>
                                        <div
                                            class="app-c-form-group"
                                            *ngIf="showSpanish">
                                            <label class="app-c-form--label"
                                                >Video Title (Spanish)</label
                                            >
                                            <input
                                                class="app-c-form-control"
                                                type="text"
                                                formControlName="label_es" />
                                        </div>
                                        <div class="app-c-form-group">
                                            <label class="app-c-form--label"
                                                >Video Duration</label
                                            >
                                            <input
                                                class="app-c-form-control"
                                                type="text"
                                                formControlName="length" />
                                        </div>

                                        <div class="icon-input">
                                            <label class="app-c-form--label"
                                                >Description</label
                                            >
                                            <ckeditor
                                                [editor]="Editor"
                                                formControlName="description"
                                                [config]="config"
                                                id="videoDescription_{{ i }}_{{
                                                    j
                                                }}">
                                            </ckeditor>
                                        </div>
                                        <div
                                            class="icon-input"
                                            *ngIf="showFrench">
                                            <label class="app-c-form--label"
                                                >Description (French)</label
                                            >
                                            <ckeditor
                                                [editor]="Editor"
                                                formControlName="description_fr"
                                                [config]="config"
                                                id="videoDescriptionFr_{{
                                                    i
                                                }}_{{ j }}">
                                            </ckeditor>
                                        </div>
                                        <div
                                            class="icon-input"
                                            *ngIf="showSpanish">
                                            <label class="app-c-form--label"
                                                >Description (Spanish)</label
                                            >
                                            <ckeditor
                                                [editor]="Editor"
                                                formControlName="description_es"
                                                [config]="config"
                                                id="videoDescriptionEs_{{
                                                    i
                                                }}_{{ j }}">
                                            </ckeditor>
                                        </div>

                                        <div
                                            class="attachments"
                                            formArrayName="attachments">
                                            <h4>File attachment(s)</h4>
                                            <div
                                                class="attachment"
                                                *ngFor="
                                                    let attachment of getAttachmentList(
                                                        i,
                                                        j
                                                    ).controls;
                                                    let r = index
                                                "
                                                [formGroupName]="r">
                                                <div class="icon-input">
                                                    <label
                                                        class="app-c-form--label"
                                                        >File Attachment ({{
                                                            r + 1
                                                        }})</label
                                                    >
                                                    <input
                                                        placeholder="File Attachment"
                                                        type="file"
                                                        (change)="
                                                            changeAttachmentUploadListener(
                                                                $event,
                                                                i,
                                                                j,
                                                                r
                                                            )
                                                        "
                                                        #input />
                                                    <div
                                                        *ngIf="
                                                            attachment.value
                                                                .filePath
                                                        ">
                                                        Uploaded:
                                                        <a
                                                            class="caption-download"
                                                            [href]="
                                                                attachment.value
                                                                    .filePath
                                                            "
                                                            target="_blank"
                                                            >Download</a
                                                        >
                                                    </div>
                                                </div>
                                                <div class="app-c-form-group">
                                                    <label
                                                        class="app-c-form--label"
                                                        >Title</label
                                                    >
                                                    <input
                                                        class="app-c-form-control"
                                                        type="text"
                                                        formControlName="title" />
                                                </div>
                                            </div>

                                            <a
                                                tabindex="0"
                                                class="app-c-btn app-c-btn--secondary app-c-btn--curve app-c-btn--sm app-c-btn--with-icon"
                                                (click)="
                                                    addVideoAttachment(i, j, {})
                                                "
                                                (keypress)="
                                                    addVideoAttachment(i, j, {})
                                                ">
                                                <svg-icon
                                                    icon="plus"
                                                    alt="plus"></svg-icon>
                                                <span>Add file attachment</span>
                                            </a>
                                        </div>

                                        <div class="icon-input">
                                            <label class="app-c-form--label"
                                                >Video File</label
                                            >
                                            <input
                                                placeholder="Video File"
                                                type="file"
                                                accept="video/mp4,video/webm,video/quicktime"
                                                (change)="
                                                    changeVideoUploadListener(
                                                        $event,
                                                        i,
                                                        j
                                                    )
                                                "
                                                #input />
                                            <small class="file-hint"
                                                >MP4 / WebM / MOV. Up to
                                                500&nbsp;MB.</small
                                            >
                                        </div>
                                        <div
                                            class="preview video-preview"
                                            *ngIf="video.value.media">
                                            <p>Video preview</p>
                                            <wt-video
                                                [mediaUrl]="video.value.media"
                                                [thumbnailUrl]="
                                                    video.value.image
                                                "
                                                [captionUrl]="
                                                    video.value.captionFile
                                                "></wt-video>
                                        </div>
                                        <div
                                            class="icon-input"
                                            *ngIf="showFrench">
                                            <label class="app-c-form--label"
                                                >Video File (French)</label
                                            >
                                            <input
                                                placeholder="Video File (French)"
                                                type="file" />
                                        </div>
                                        <div
                                            class="icon-input"
                                            *ngIf="showSpanish">
                                            <label class="app-c-form--label"
                                                >Video File (Spanish)</label
                                            >
                                            <input
                                                placeholder="Video File (Spanish)"
                                                type="file" />
                                        </div>

                                        <div class="icon-input">
                                            <label class="app-c-form--label"
                                                >Video Image</label
                                            >
                                            <input
                                                placeholder="Video Image"
                                                type="file"
                                                accept="image/png,image/jpeg,image/jpg,image/webp"
                                                (change)="
                                                    changeVideoImageUploadListener(
                                                        $event,
                                                        i,
                                                        j
                                                    )
                                                " />
                                            <small class="file-hint"
                                                >PNG, JPG or WebP. Recommended ≤
                                                2&nbsp;MB.</small
                                            >
                                        </div>
                                        <div
                                            class="preview image-preview"
                                            *ngIf="video.value.image">
                                            <p>Image preview</p>
                                            <img [src]="video.value.image" />
                                        </div>
                                        <div
                                            class="icon-input"
                                            *ngIf="showFrench">
                                            <label class="app-c-form--label"
                                                >Video Image (French)</label
                                            >
                                            <input
                                                placeholder="Video Image (French)"
                                                type="file" />
                                        </div>
                                        <div
                                            class="icon-input"
                                            *ngIf="showSpanish">
                                            <label class="app-c-form--label"
                                                >Video Image (Spanish)</label
                                            >
                                            <input
                                                placeholder="Video Image (Spanish)"
                                                type="file" />
                                        </div>

                                        <div class="icon-input">
                                            <label class="app-c-form--label"
                                                >Caption File</label
                                            >
                                            <input
                                                placeholder="Caption File"
                                                type="file"
                                                accept=".vtt,.srt"
                                                (change)="
                                                    changeCaptionUploadListener(
                                                        $event,
                                                        i,
                                                        j
                                                    )
                                                " />
                                            <small class="file-hint"
                                                >WebVTT (.vtt) or SubRip
                                                (.srt).</small
                                            >
                                        </div>
                                        <div
                                            class="preview caption-preview"
                                            *ngIf="video.value.captionFile">
                                            <p>
                                                Caption Upload:
                                                <a
                                                    class="caption-download"
                                                    [href]="
                                                        video.value.captionFile
                                                    "
                                                    target="_blank"
                                                    >Download</a
                                                >
                                            </p>
                                        </div>
                                        <div
                                            class="icon-input"
                                            *ngIf="showFrench">
                                            <label class="app-c-form--label"
                                                >Caption File (French)</label
                                            >
                                            <input
                                                placeholder="Caption File (French)"
                                                type="file" />
                                        </div>
                                        <div
                                            class="icon-input"
                                            *ngIf="showSpanish">
                                            <label class="app-c-form--label"
                                                >Caption File (Spanish)</label
                                            >
                                            <input
                                                placeholder="Caption File (Spanish)"
                                                type="file" />
                                        </div>

                                        <div class="icon-input">
                                            <label class="app-c-form--label"
                                                >Audio File</label
                                            >
                                            <input
                                                placeholder="Audio file"
                                                type="file"
                                                accept="audio/mpeg,audio/mp3,audio/wav,audio/m4a,audio/aac"
                                                (change)="
                                                    changeAudioUploadListener(
                                                        $event,
                                                        i,
                                                        j
                                                    )
                                                " />
                                            <small class="file-hint"
                                                >MP3, WAV, M4A or AAC.</small
                                            >
                                        </div>
                                        <div
                                            class="preview audio-preview"
                                            *ngIf="video.value.audioFile">
                                            <label class="app-c-form--label"
                                                >Audio preview</label
                                            >
                                            <wt-audio
                                                [mediaUrl]="
                                                    video.value.audioFile
                                                ">
                                            </wt-audio>
                                        </div>
                                        <div
                                            class="icon-input"
                                            *ngIf="showFrench">
                                            <label class="app-c-form--label"
                                                >Audio File (French)</label
                                            >
                                            <input
                                                placeholder="Audio File (French)"
                                                type="file" />
                                        </div>
                                        <div
                                            class="icon-input"
                                            *ngIf="showSpanish">
                                            <label class="app-c-form--label"
                                                >Audio File (Spanish)</label
                                            >
                                            <input
                                                placeholder="Audio File (Spanish)"
                                                type="file" />
                                        </div>

                                        <!-- In-app links under the video. Optional; admins can
										     attach one or more CTAs that take the viewer to
										     Mood Check, a tool, an assessment, or another series. -->
                                        <div class="in-app-link-block">
                                            <h4>In-app links (optional)</h4>
                                            <p class="hint">
                                                Add one or more buttons below
                                                the video that take the viewer
                                                to a Mood Check, a specific tool
                                                / assessment, or another Series.
                                            </p>
                                            <div formArrayName="inAppLinks">
                                                <div
                                                    class="in-app-link-row"
                                                    *ngFor="
                                                        let link of getInAppLinksList(
                                                            i,
                                                            j
                                                        ).controls;
                                                        let k = index
                                                    "
                                                    [formGroupName]="k">
                                                    <div
                                                        class="app-c-form-group">
                                                        <label
                                                            class="app-c-form--label"
                                                            >Destination</label
                                                        >
                                                        <select
                                                            class="app-c-form-control"
                                                            formControlName="type">
                                                            <option value="">
                                                                — Select —
                                                            </option>
                                                            <option
                                                                value="moodcheck">
                                                                Mood Check
                                                            </option>
                                                            <option
                                                                value="tool">
                                                                Tool (route key)
                                                            </option>
                                                            <option
                                                                value="assessment">
                                                                Assessment (id)
                                                            </option>
                                                            <option
                                                                value="series">
                                                                Another Series
                                                                (course key)
                                                            </option>
                                                        </select>
                                                    </div>
                                                    <div
                                                        class="app-c-form-group"
                                                        *ngIf="
                                                            link.get('type')
                                                                .value &&
                                                            link.get('type')
                                                                .value !==
                                                                'moodcheck'
                                                        ">
                                                        <label
                                                            class="app-c-form--label">
                                                            <span
                                                                *ngIf="
                                                                    link.get(
                                                                        'type'
                                                                    ).value ===
                                                                    'tool'
                                                                "
                                                                >Tool route key
                                                                (e.g.
                                                                practice/zen-room)</span
                                                            >
                                                            <span
                                                                *ngIf="
                                                                    link.get(
                                                                        'type'
                                                                    ).value ===
                                                                    'assessment'
                                                                "
                                                                >Assessment
                                                                ID</span
                                                            >
                                                            <span
                                                                *ngIf="
                                                                    link.get(
                                                                        'type'
                                                                    ).value ===
                                                                    'series'
                                                                "
                                                                >Series key
                                                                (CourseKey)</span
                                                            >
                                                        </label>
                                                        <input
                                                            class="app-c-form-control"
                                                            type="text"
                                                            formControlName="target" />
                                                    </div>
                                                    <div
                                                        class="app-c-form-group">
                                                        <label
                                                            class="app-c-form--label"
                                                            >Button label</label
                                                        >
                                                        <input
                                                            class="app-c-form-control"
                                                            type="text"
                                                            formControlName="label"
                                                            placeholder='e.g. "Try a Mood Check"' />
                                                    </div>
                                                    <div
                                                        class="in-app-link-row__actions">
                                                        <button
                                                            type="button"
                                                            class="app-c-btn app-c-btn--secondary app-c-btn--curve app-c-btn--sm"
                                                            (click)="
                                                                removeInAppLink(
                                                                    i,
                                                                    j,
                                                                    k
                                                                )
                                                            ">
                                                            Remove link
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <button
                                                type="button"
                                                class="app-c-btn app-c-btn--secondary app-c-btn--curve app-c-btn--sm"
                                                (click)="addInAppLink(i, j)">
                                                Add a link
                                            </button>
                                        </div>
                                    </div>
                                </details>
                            </div>
                            <a
                                tabindex="0"
                                class="app-c-btn app-c-btn--secondary app-c-btn--curve app-c-btn--sm app-c-btn--with-icon"
                                (click)="addVideo(i, {})"
                                (keypress)="addVideo(i, {})">
                                <svg-icon icon="plus" alt="plus"></svg-icon>
                                <span>Add Video</span>
                            </a>
                        </ng-container>
                    </details>
                </div>
                <a
                    tabindex="0"
                    class="app-c-btn app-c-btn--primary app-c-btn--curve app-c-btn--with-icon"
                    (click)="addCourseItem({})"
                    (keypress)="addCourseItem({})">
                    <svg-icon icon="plus" alt="plus"></svg-icon>
                    <span>Add Chapter</span>
                </a>
                <div class="fixed-footer">
                    <p
                        class="red"
                        *ngIf="
                            submitButtonPressed &&
                            !courseEditForm.valid &&
                            errors === ''
                        ">
                        Please check the errors
                    </p>
                    <p class="red">{{ errors }}</p>
                    <button
                        type="button"
                        class="app-c-btn app-c-btn--primary app-c-btn--curve"
                        (click)="doSave()">
                        Save
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>
